<template>
	<div id="" ref="">

	</div>
</template>

<script>

/* 因菜单中多个菜单项使用同一个vue组件, 传递不同的参数, vue自身的机制导致点击菜单时无法自动刷新
   通过本组件跳转到目标组件, 实现刷新处理
 */
export default {
	name: 'routerMid',
	components:{

	},
	data () {
		return {
		}
	},
	mounted: function(){
		this.$router.push( {path:this.$route.query.path, query:this.$route.query} );
	},
	computed:{

	},
	methods:{

	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// routerMid.vue?5e92e93d